import React from 'react';
import { businessCards } from '../data/company';
import { renderRich } from '../utils/richText';
import { Card, CardFoot, CardTag } from './Card';
import { RichList } from './RichList';
import { Section } from './Section';
export function BusinessSection() {
  return <Section id="negocio" number="03" title="Qué vende Massive Faith LLC" subtitle="La empresa tiene una sola actividad: la venta de un kit de libros digitales educativos para chicos. Cada cobro que procesamos corresponde a ese producto, descripto en detalle en esta página." data-id="element-14" data-mp="xoi92xa4l6cv">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-15" data-mp="9z7ha5ar6mav">
        {businessCards.map(card => <Card key={card.title} data-id="element-16" data-mp="epw7zielzf8y">
            {card.tag && <CardTag data-id="element-17" data-mp="eqz17wzelts1">{card.tag}</CardTag>}
            <h3 className="mb-2 text-[19px] font-bold tracking-[-0.01em] text-fg" data-id="element-18" data-mp="3dg64go9hqqtk">{card.title}</h3>
            {card.description && <p className="mb-3.5 text-[14.5px] leading-relaxed text-muted" data-id="element-19" data-mp="3idpipo66v3li">{renderRich(card.description)}</p>}
            <RichList items={card.items} className="text-[14.5px]" data-id="element-20" data-mp="26309kfdnvm64" />
            {card.foot && <CardFoot data-id="element-21" data-mp="214ysu13pjyxt">{renderRich(card.foot)}</CardFoot>}
          </Card>)}
      </div>
    </Section>;
}